import moment from 'moment/moment'
import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = {
  asap: 'ASAP',
  settime: 'SET TIME'
}
const langValue = function (targetVal) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue[targetVal]
  })
  return obj
}

const dayOfWeek = [
  { id: 'mon', name: '월', available: true, weekday: 2 },
  { id: 'tue', name: '화', available: true, weekday: 3 },
  { id: 'wed', name: '수', available: true, weekday: 4 },
  { id: 'thu', name: '목', available: true, weekday: 5 },
  { id: 'fri', name: '금', available: true, weekday: 6 },
  { id: 'sat', name: '토', available: true, weekday: 7 },
  { id: 'sun', name: '일', available: true, weekday: 1 }
]
const timeRange = function () {
  let timeRange = []
  for (let i = 0; i < 24; i++) {
    timeRange.push({
      value: ('0' + i).slice(-2),
      active: true
    })
  }
  return timeRange
}

export default {
  id: 'datetime',
  name: 'datetime',
  type: 'action',
  moduleName: 'editor_module_datetime',
  dataSet: {
    mods: 'datetime',
    extra: true,
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'datetime',
        name: 'asap',
        value: langValue('asap'),
        detail: {
          options: ['background', 'border', 'text', 'radius']
        }
      },
      {
        columnId: UNIQUE.mid(),
        type: 'datetime',
        name: 'settime',
        value: langValue('settime'),
        detail: {
          options: ['background', 'border', 'text', 'radius']
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'flex',
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'datetime',
      isRequired: true,
      label: '',
      labelValue: '',
      asap: {
        active: true,
        label: langValue('asap')
      },
      settime: {
        active: true,
        label: langValue('settime'),
        day: '1',
        time: 30,
        dateFrom: moment().toISOString(),
        dateTo: moment().add(1, 'day').toISOString()
      },
      activeDate: true,
      activeTime: true,
      hasTerm: false,
      dateFrom: moment().toISOString(),
      dateTo: moment().add(5, 'day').toISOString(),
      hasRangeDay: false,
      rangeDayNumber: '3',
      dayOfWeek: dayOfWeek,
      disabledDays: [],
      allowedToday: true,
      allowedPast: true,
      hasRangeTime: false,
      rangeTimeNumber: timeRange()
    },
    detail: {}
  }
}
